import { useQuery } from '@tanstack/react-query';

import { useAuthorization } from '@/auth/hooks/use-authorization';

import type { userLoader } from './user-loader';
import { useLoaderData } from 'react-router-dom';
import { fetchWhoAmI } from '@/api/v4/auth.api';
import { QueryKey } from '@/config/query-client';
import { getTimeInMs } from '@/helpers/get-time-in-ms';

export const currentUserQuery = () => ({
  queryKey: [QueryKey.WhoAmI],
  queryFn: fetchWhoAmI,
  staleTime: getTimeInMs(15, 'minute'),
  gcTime: getTimeInMs(1, 'day'),
});

export const useCurrentUser = () => {
  const { isUserAuthorized } = useAuthorization();
  const initialData = useLoaderData() as Awaited<
    ReturnType<ReturnType<typeof userLoader>>
  >;

  return useQuery({
    ...currentUserQuery(),
    retry: 1,
    enabled: isUserAuthorized,
    networkMode: 'offlineFirst',
    initialData,
  });
};
